import axios from 'axios';
import types from './actionsTypes';
import config from '../../config';
import { handleSnackBar } from '../global/actions';

axios.interceptors.request.use(function (config) {
  const token = authHeader();
  config.headers.Authorization = token;
  return config;
});

const API_URL = config.apiUrl;

const register = (data) => async (dispatch) => {

  try {
    const response = await axios({
      method: 'post',
      url: API_URL + 'signup',
      data: data
    });
    dispatch(handleSnackBar({ open: true, message: response.data?.message ? response.data?.message : `You are successfully signed up.`, severity: 'success' }));
    return response.data.data;

  } catch (error) {

    if (error.response) {
      dispatch(handleSnackBar({ open: true, message: `${error.response.data.message}`, severity: 'error' }));
    } else {
      dispatch(handleSnackBar({ open: true, message: `${error}`, severity: 'error' }));
    }

  }
};

const setLogin = (payload = {}) => ({ type: types.SET_LOGIN, payload: payload });

export const setLogout = (payload = {}) => ({ type: types.RESET_LOGIN });

export const togglePageLoader = (payload = {}) => ({ type: types.TOGGLE_PAGE_LOADER });

const login = (data) => async (dispatch) => {
  try {
    const response = await axios({
      method: 'post',
      url: API_URL + 'login',
      data: data,
    });

    if (response.data.success) {
      localStorage.removeItem('token');
      localStorage.setItem('token', response.data.token);
      dispatch(setLogin({ username: response.data.username, userId: response.data.id, firstName: response.data.firstName, lastName: response.data.lastName }));
    }
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("Response error: ",error.response)
      dispatch(handleSnackBar({ open: true, message: `${error.response.data.message}`, severity: 'error' }));
      return error.response?.data || {};
    } else {
      dispatch(handleSnackBar({ open: true, message: `${error}`, severity: 'error' }));
    }

  }
};

export const authCheck = (noOverlay) => async (dispatch) => {
  try {
    const response = await axios({
      method: 'GET',
      url: API_URL + 'auth/check',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (response.data.success) {
      if (!noOverlay) {
        dispatch(togglePageLoader());
        dispatch(setLogin({ username: response.data.username, userId: response.data.id, firstName: response.data.firstName, lastName: response.data.lastName }));
      }
    }

    return;
  } catch (error) {
    getCurrentUser() && dispatch(handleSnackBar({ open: true, message: `Session timed out. Please login`, severity: 'error' }));
    dispatch(logout());
  }
};

const logout = (showSnackbar, blueprintId=undefined) => async (dispatch, getState) => {
  try {

    dispatch(togglePageLoader());

    const docID = getState()?.global?.details?.docid ? getState()?.global?.details?.docid : null
    const ticket = localStorage.getItem(`mode_${docID}`);
    const query = docID != null ? `?ticket=${ticket}`: '';
    
   
    await axios({
      method: 'delete',
      url: API_URL + 'logout' + query,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    console.log({docID})

    localStorage.removeItem('token');
    localStorage.removeItem(`mode_${docID}`);

    if (showSnackbar) dispatch(handleSnackBar({ open: true, message: `Session timed out. Please login`, severity: 'error' }));
    dispatch(setLogout());
  } catch (error) {
    dispatch(setLogout());
  }
};

const getCurrentUser = () => {
  return localStorage.getItem('token');
};

const authHeader = () => {
  const user = localStorage.getItem('token');
  if (user) {
    return user;
  } else {
    return null;
  }
};

export const changePasswordAction = (userData) => async (dispatch) => {
  const res = await axios({
    method: 'post',
    url: API_URL + 'user/change/password',
    data: userData,
  });

  if (res != null) return res.data;
}

export const sendLink = (resetPayload) => async (dispatch) => {

  const response = await axios({
    method: 'post',
    url: API_URL + 'user/sendresetlink',
    data: resetPayload,
  })

  if (response != null) return response.data
}

export default {
  register,
  login,
  logout,
  getCurrentUser,
  authHeader,
  setLogin,
  authCheck,
  sendLink
};
